import ArticleImageOne from '../../assets/images/ResourceArticles/ArticleImageOne.png';
import ArticleImageTwo from '../../assets/images/ResourceArticles/ArticleImageTwo.png';
import ArticleImageThree from '../../assets/images/ResourceArticles/ArticleImageThree.png';
import ArticleImageFour from '../../assets/images/ResourceArticles/ArticleImageFour.png';
import ArticleImageFive from '../../assets/images/ResourceArticles/ArticleImageFive.png';
import ArticleImageSix from '../../assets/images/ResourceArticles/ArticleImageSix.png';
import ArticleImageSeven from '../../assets/images/ResourceArticles/ArticleImageSeven.png';
import ArticleImageEight from '../../assets/images/ResourceArticles/ArticleImageEight.png';
import ArticleImageNine from '../../assets/images/ResourceArticles/ArticleImageNine.png';
import ArticleImageTen from '../../assets/images/ResourceArticles/ArticleImageTen.png';

export const resourceArticleImages = [
  ArticleImageOne,
  ArticleImageTwo,
  ArticleImageThree,
  ArticleImageFour,
  ArticleImageFive,
  ArticleImageSix,
  ArticleImageSeven,
  ArticleImageEight,
  ArticleImageNine,
  ArticleImageTen,
];

/**
 * Get a random resource article image from the available images
 */
export const getRandomArticleImage = (): string => {
  const randomIndex = Math.floor(Math.random() * resourceArticleImages.length);
  return resourceArticleImages[randomIndex];
};

/**
 * Separator between the user and article portions of the hash key.
 *
 * A null byte is used (rather than a printable character like `-`) so the
 * combined key is unambiguous: values such as ("user-1", "2-article") and
 * ("user", "1-2-article") can never collide into the same hash input.
 */
const HASH_KEY_SEPARATOR = '\0';

// Prime multiplier used in the hash function. 31 is a common choice that produces
// good distribution and minimizes collisions in simple string hashes.
const HASH_MULTIPLIER = 31;

/**
 * Largest 32-bit signed integer (2^31 - 1). Used as a modulus to keep the
 * running hash bounded within a safe integer range.
 */
const HASH_MODULUS = 2147483647;

/**
 * Deterministically map a string to a non-negative integer (djb2-style hash).
 * Same input always produces the same output.
 */
const hashString = (value: string): number => {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    // Keep the value bounded so it never grows past a safe integer.
    hash = (hash * HASH_MULTIPLIER + value.charCodeAt(i)) % HASH_MODULUS;
  }
  return hash;
};

/**
 * Deterministic index into resourceArticleImages for a user + article key.
 * Exposed for testing / reuse.
 */
export const getArticleImageIndexForUser = (userId: string, articleKey: string): number =>
  hashString(`${userId}${HASH_KEY_SEPARATOR}${articleKey}`) % resourceArticleImages.length;

/**
 * Get a stable article image for a given user + article combination.
 *
 * The same (userId, articleKey) pair always returns the same image, so the
 * assignment is consistent across sessions without persisting anything.
 * `articleKey` can be any stable article identifier; Resources cards use the article url,
 * the one key shared by library, search results and favorites.
 */
export const getArticleImageForUser = (userId: string, articleKey: string): string => {
  const index = getArticleImageIndexForUser(userId, articleKey);
  return resourceArticleImages[index];
};
